import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  title: string;
  comdata: any;
  comopt: any;
  branch: string;
  branchdata: any;
  branchname: any;
  childdatarec: any;

  constructor(private userService: UserService) { }

  ngOnInit() {
    this.setcompany();
  }
  setcompany() {
    this.comdata = this.userService.GetCompany();
    this.comdata.subscribe(
      (response: any) => {
        this.title = response;
        localStorage.setItem('company', response);
      }
    )
  }
  datafromchild(data)
  {

    this.branchname=data;
    console.log("Branch name passed");
    console.log(this.branchname);
    
  }
  getbranch() {
    debugger;
    this.branch = localStorage.getItem('BRANCH_ID');
    this.branchdata = this.userService.GetBranchName(this.branch);
    this.branchdata.subscribe(
      (Response: any) => {
        this.branchname = Response;
        localStorage.setItem('Branch_name_db', Response);
      }
    )

  }

}



// WEBPACK FOOTER //
// ./src/app/common/header/header.component.ts